export { default, getServerSideProps } from '../../src/pages/retailers/[slug]';
